var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCoverageCheckPopover)?_c('approval-check-popover',{attrs:{"popover-id":_vm.popoverTriggerId,"title":_vm.approvalRuleConfig.title,"text":_vm.approvalRuleConfig.popoverText,"documentation-link":_vm.documentationLink,"documentation-text":_vm.approvalRuleConfig.documentationText}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }